import jsPDF from "jspdf";
import "jspdf-autotable";

const generateDepartmentPerformancePDF = (data) => {
  if (!data) {
    console.error("No data provided for PDF generation");
    return;
  }

  const doc = new jsPDF();

  // --- Title ---
  doc.setFontSize(20);
  doc.text("Department Performance Report", 14, 22);

  // --- Department Info ---
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(`Department: ${data.departmentName}`, 14, 35);
  
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(`Department ID: ${data.departmentId}`, 14, 42);
  doc.text(`Total Employees: ${data.totalEmployees}`, 14, 49);
  doc.text(`Reviewed Employees: ${data.reviewedEmployeeCount}`, 14, 56);
  doc.text(`Participation Rate: ${data.participationRate}%`, 14, 63);
  
  // --- Performance Metrics ---
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Performance Metrics", 14, 75);
  
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(`Average Total Score: ${data.avgTotalScore}`, 14, 82);
  doc.text(`Average Weighted Accountability: ${data.avgWeightedAccountability}`, 14, 89);
  doc.text(`Average Weighted Performance: ${data.avgWeightedPerformance}`, 14, 96);
  doc.text(`Average Weighted Dynamic Organization: ${data.avgWeightedDynamicOrg}`, 14, 103);
  doc.text(`Average Raw Accountability: ${data.avgRawAccountability}`, 14, 110);
  doc.text(`Average Raw Performance: ${data.avgRawPerformance}`, 14, 117);
  doc.text(`Average Raw Dynamic Organization: ${data.avgRawDynamicOrg}`, 14, 124);
  
  // --- Distribution Table ---
  if (data.distribution && data.distribution.length > 0) {
    doc.autoTable({
      head: [["Grade Code", "Grade Name", "Count", "Grade"]],
      body: data.distribution.map(item => [
        item.code,
        item.name,
        item.count,
        item.grade
      ]),
      startY: 135,
      headStyles: {
        fillColor: [50, 50, 50],
        textColor: 255,
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
    });
  }
  
  // --- Footer ---
  doc.setFontSize(10);
  doc.text(`Report Generated: ${new Date().toLocaleString()}`, 14, doc.internal.pageSize.height - 10);

  // --- Save ---
  doc.save(`department_performance_${data.departmentName.replace(/\s+/g, '_')}.pdf`);
};

export default generateDepartmentPerformancePDF;